import { Entity } from './entities.model';
import { BloodType } from './general_models';
import { Relation } from './relations.model';
import { League } from './leagues.model';
import { Club } from './clubs.model';
import { IdValueType } from '../core/helpers/indexables.helpers';
import { Indexable } from '../core/models/indexable';
// tslint:disable: variable-name

export type UniformSize = 'PP' | 'P' | 'M' | 'G' | 'GG' | 'EXG' | '4G' | '5G';
export type REFEREE_TYPE = '1' | '2' | 'N' | 'C' | 'R' | 'A';

export const REFEREE_TYPE_NAMES: Indexable<REFEREE_TYPE, string> = {
  1: 'Árbitro Principal',
  2: 'Árbitro Auxiliar',
  N: 'Anotador',
  C: 'Cronometrista',
  R: 'Representante',
  A: 'Qualquer Árbitro'
};

export const REFEREE_TYPES: IdValueType<REFEREE_TYPE, string>[] = [
  { id: '1', value: 'Árbitro Principal' },
  { id: '2', value: 'Árbitro Auxiliar' },
  { id: 'N', value: 'Anotador' },
  { id: 'C', value: 'Cronometrista' },
  { id: 'R', value: 'Representante' },
  { id: 'A', value: 'Qualquer Árbitro' }
];

export function getRefereeTypeName(referee_type): string {
  const option = REFEREE_TYPES.find(_r => _r.id === referee_type);
  if (!option) {
    return null;
  }
  return option.value;
}

export class UniformInfo {
  last_purchase?: Date | string;
  size?: UniformSize;
}
export class UniformField {
  coat: UniformInfo;
  short: UniformInfo;
  shirt: UniformInfo;
}

export class LeagueRelation extends Relation {
  league: League;
  clubs: Club[];
  referees: Referee[];
}

export class Referee extends Entity {
  sport_id: number;
  weight?: number;
  height?: number;
  blood_type?: BloodType;
  mobile_phone?: string;
  residential_phone?: string;
  current_uf?: string;
  graduation_year?: number;
  national_board_year?: number;
  uniform?: UniformField;
  monthly_income?: number;
  acting_region?: string;

  league_relations?: LeagueRelation[];

}
